import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.333 25.083A2.915 2.915 0 0 0 13.417 28v16.333a2.915 2.915 0 0 0 2.916 2.917h23.334a2.915 2.915 0 0 0 2.916-2.917V28a2.915 2.915 0 0 0-2.916-2.917zM9.917 28a6.415 6.415 0 0 1 6.416-6.417h23.334A6.415 6.415 0 0 1 46.083 28v16.333a6.415 6.415 0 0 1-6.416 6.417H16.333a6.415 6.415 0 0 1-6.416-6.417zM17.283 13.625C18.493 8.831 22.806 5.25 28 5.25c6.12 0 11.083 4.963 11.083 11.083a1.75 1.75 0 1 1-3.5 0A7.584 7.584 0 0 0 28 8.75c-3.533 0-6.491 2.434-7.324 5.732a1.75 1.75 0 1 1-3.393-.857",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M37.333 14.583c.967 0 1.75.784 1.75 1.75v7a1.75 1.75 0 1 1-3.5 0v-7c0-.966.784-1.75 1.75-1.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }